var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShare = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.337 8.664c0.964 0.013 1.832 0.414 2.458 1.053l0.001 0.001 9.25-5.385c-0.111-0.286-0.176-0.618-0.176-0.964 0-0.011 0-0.022 0-0.032l-0 0.002c0-1.843 1.494-3.336 3.336-3.336s3.336 1.494 3.336 3.336v0c-0.020 1.834-1.502 3.316-3.335 3.336l-0.002 0c-0.964-0.013-1.832-0.414-2.458-1.053l-0.001-0.001-9.247 5.385c0.111 0.296 0.176 0.638 0.176 0.995s-0.064 0.699-0.182 1.015l0.007-0.020 9.25 5.385c0.626-0.64 1.494-1.040 2.456-1.053l0.002-0c1.834 0.021 3.316 1.502 3.336 3.335l0 0.002c0 1.843-1.494 3.336-3.336 3.336s-3.336-1.494-3.336-3.336v0c0.001-0.357 0.066-0.699 0.182-1.016l-0.007 0.021-9.252-5.385c-0.626 0.64-1.494 1.040-2.456 1.053l-0.002 0c-0 0-0.001 0-0.002 0-1.842 0-3.335-1.493-3.335-3.335 0-0.001 0-0.001 0-0.002v0c0.021-1.834 1.502-3.316 3.335-3.336l0.002-0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share.23bbcace.svg";
export { ForwardRef as ReactComponent };